import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.DisableUsageReminder.title',
    defaultMessage: 'Disable usage reminder email',
  },
  enabled: {
    id: 'containers.OrderPage.components.TaskPage.components.DisableUsageReminder.enabled',
    defaultMessage: 'Usage reminder email enabled for task',
  },
  disabled: {
    id: 'containers.OrderPage.components.TaskPage.components.DisableUsageReminder.disabled',
    defaultMessage: 'Usage reminder email disabled for task',
  },
})
